import tooltips from "./tooltips";

export default {
  // bng: {
  //   days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
  //   data: [
  //     {
  //       time: "8:00 AM",
  //       activities: [
  //         [
  //           {
  //             type: "physical",
  //             label: "Power Walk",
  //             tooltip: tooltips.powerwalk,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Tabata Training",
  //             tooltip: tooltips.tabata,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Power Walk",
  //             tooltip: tooltips.powerwalk,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Caribbean Beach Shred",
  //             tooltip: tooltips.caribnbchs,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Abs Session",
  //             tooltip: tooltips.abssn,
  //           },
  //         ],
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "11:00 AM",
  //       activities: [
  //         [
  //           {
  //             type: "water",
  //             label: "Aqua Tabata",
  //             tooltip: tooltips.aquatabata,
  //           },
  //         ],
  //         [
  //           {
  //             type: "water",
  //             label: "Aqua Fitness",
  //             tooltip: tooltips.aqua,
  //           },
  //         ],
  //         [
  //           {
  //             type: "water",
  //             label: "Splish-Splash",
  //             tooltip: tooltips.splish,
  //           },
  //         ],
  //         [
  //           {
  //             type: "water",
  //             label: "Aqua Fitness",
  //             tooltip: tooltips.aqua,
  //           },
  //         ],
  //         [
  //           {
  //             type: "field",
  //             label: "Kids Beach FUN",
  //             tooltip: tooltips.beachfun,
  //           },
  //         ],
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "3:00 PM",
  //       activities: [
  //         [
  //           {
  //             type: "physical",
  //             label: "Gym Assistance",
  //             tooltip: tooltips.gymasst,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Gym Assistance",
  //             tooltip: tooltips.gymasst,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Jammin !!!",
  //             tooltip: tooltips.jammin,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Gym Assistance",
  //             tooltip: tooltips.gymasst,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Gym Assistance",
  //             tooltip: tooltips.gymasst,
  //           },
  //         ],
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "4:00 PM",
  //       activities: [
  //         [
  //           {
  //             type: "physical",
  //             label: "Kids Yoga",
  //             tooltip: tooltips.yoga,
  //           },
  //         ],
  //         null,
  //         [
  //           {
  //             type: "relaxation",
  //             label: "Stretching Session",
  //             tooltip: tooltips.streching,
  //           },
  //         ],
  //         null,
  //         [
  //           {
  //             type: "physical",
  //             label: "Kids Yoga",
  //             tooltip: tooltips.yoga,
  //           },
  //         ],
  //         null,
  //         null,
  //       ],
  //     },
  //   ],
  // },
  // bbo: {
  //   days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
  //   data: [
  //     {
  //       time: "8:00 AM",
  //       activities: [
  //         [
  //           {
  //             type: "relaxation",
  //             label: "Couples Stretching",
  //             tooltip: tooltips.couplesstrch,
  //           },
  //         ],
  //         [
  //           {
  //             type: "relaxation",
  //             label: "Power Walk",
  //             tooltip: tooltips.powerwalk,
  //           },
  //         ],
  //         null,
  //         [
  //           {
  //             type: "relaxation",
  //             label: "Stretching Session",
  //             tooltip: tooltips.streching,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Caribbean Beach Shred",
  //             tooltip: tooltips.caribnbchs,
  //           },
  //         ],
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "10:30 AM",
  //       activities: [
  //         [
  //           {
  //             type: "water",
  //             label: "Aqua Fitness",
  //             tooltip: tooltips.aqua,
  //           },
  //         ],
  //         null,
  //         [
  //           {
  //             type: "water",
  //             label: "Aqua Fitness",
  //             tooltip: tooltips.aqua,
  //           },
  //         ],
  //         [
  //           {
  //             type: "water",
  //             label: "Aqua Fitness",
  //             tooltip: tooltips.aqua,
  //           },
  //         ],
  //         null,
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "11:15 AM",
  //       activities: [
  //         null,
  //         [
  //           {
  //             type: "water",
  //             label: "Splish-Splash",
  //             tooltip: tooltips.splish,
  //           },
  //         ],
  //         null,
  //         null,
  //         null,
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "1:30 PM",
  //       activities: [
  //         null,
  //         null,
  //         null,
  //         null,
  //         [
  //           {
  //             type: "physical",
  //             label: "Kids Yoga",
  //             tooltip: tooltips.yoga,
  //           },
  //         ],
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "3:00 PM",
  //       activities: [
  //         null,
  //         [
  //           {
  //             type: "physical",
  //             label: "BasketBall",
  //             tooltip: tooltips.basketball,
  //           },
  //           {
  //             type: "physical",
  //             label: "Gym Assistance",
  //             tooltip: tooltips.gymasst,
  //           },
  //         ],
  //         null,
  //         null,
  //         [
  //           {
  //             type: "physical",
  //             label: "Absolute Abs",
  //             tooltip: tooltips.absoluteabs,
  //           },
  //         ],
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "3:30 PM",
  //       activities: [
  //         null,
  //         null,
  //         null,
  //         [
  //           {
  //             type: "physical",
  //             label: "BasketBall",
  //             tooltip: tooltips.basketball,
  //           },
  //         ],
  //         null,
  //         null,
  //         null,
  //       ],
  //     },
  //     {
  //       time: "4:00 PM",
  //       activities: [
  //         [
  //           {
  //             type: "physical",
  //             label: "Gym Assistance",
  //             tooltip: tooltips.gymasst,
  //           },
  //         ],
  //         null,
  //         [
  //           {
  //             type: "physical",
  //             label: "Gym Assistance",
  //             tooltip: tooltips.gymasst,
  //           },
  //           {
  //             type: "physical",
  //             label: "Tabata Session",
  //             tooltip: tooltips.tabata,
  //           },
  //         ],
  //         [
  //           {
  //             type: "physical",
  //             label: "Gym Assistance",
  //             tooltip: tooltips.gymasst,
  //           },
  //         ],
  //         null,
  //         null,
  //         null,
  //       ],
  //     },
  //   ],
  // },
  btc: {
    days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
    data: [
      {
        time: "7:00 AM",
        activities: [
          [
            {
              type: "physical",
              label: "Absolute Abs",
              tooltip: tooltips.absoluteabs,
            },
          ],
          [
            {
              type: "relaxation",
              label: "Stretching Session",
              tooltip: tooltips.streching,
            },
          ],
          [
            {
              type: "relaxation",
              label: "Power Walk",
              tooltip: tooltips.powerwalk,
            },
          ],
          [
            {
              type: "relaxation",
              label: "Couples Stretching Session",
              tooltip: tooltips.couplesstrch,
            },
          ],
          [
            {
              type: "relaxation",
              label: "Stretching Session",
              tooltip: tooltips.streching,
            },
          ],
          null,
          null,
        ],
      },
      {
        time: "10:30 AM",
        activities: [
          [
            {
              type: "water",
              label: "Aqua Tabata",
              tooltip: tooltips.aqua,
            },
          ],
          [
            {
              type: "water",
              label: "Aqua Fitness",
              tooltip: tooltips.aquatabata,
            },
          ],
          [
            {
              type: "water",
              label: "Splish-Splash",
              tooltip: tooltips.splish,
            },
          ],
          [
            {
              type: "water",
              label: "Aqua Tabata",
              tooltip: tooltips.aquatabata,
            },
          ],
          [
            {
              type: "water",
              label: "Aqua Fitness",
              tooltip: tooltips.aqua,
            },
          ],
          null,
          null,
        ],
      },
      {
        time: "3:00 PM",
        activities: [
          [
            {
              type: "physical",
              label: "Gym Assistance",
              tooltip: tooltips.gymasst,
            },
          ],
          [
            {
              type: "physical",
              label: "Tabata Training (16yrs & older)",
              tooltip: tooltips.tabata,
            },
          ],
          [
            {
              type: "physical",
              label: "Gym Assistance",
              tooltip: tooltips.gymasst,
            },
          ],
          [
            {
              type: "physical",
              label: "Caribbean Beach Shred",
              tooltip: tooltips.caribnbchs,
            },
          ],
          [
            {
              type: "relaxation",
              label: "Stretching Session",
              tooltip: tooltips.streching,
            },
          ],
          null,
          null,
        ],
      },
    ],
  },
};
